import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionScene のスタイル
 */
export const hotlineLpSectionSceneStyle = tv({
    slots: {
        backgroundImage1: [
            'absolute -z-10',
            'w-[104px] left-[-50px] bottom-[-45px]',
            'md:w-[185px] md:left-[-180px] md:bottom-[-70px]',
        ],
        backgroundImage2: [
            'absolute -z-10',
            'w-[208px] right-[-70px] top-[-105px]',
            'md:w-[414px] md:right-[-245px] md:top-[-200px]',
        ],
        base: ['max-w-[1128px] mx-auto'],
        button: ['mt-40 lg:mt-64', 'text-center'],
        listItemIcon: ['text-[#4881F1] lg:text-[24px]', 'self-start'],
        listItemLi: [
            'flex gap-x-8 lg:gap-x-12 items-center',
            'text-[14px] lg:text-[16px]',
            'leading-[21px]',
        ],
        listItemTitle: ['text-[16px] lg:text-[20px] font-bold leading-[24px]'],
        listItemUl: ['flex flex-col gap-y-8 lg:gap-y-20'],
        listItemWrapper: [
            'lg:row-span-2 grid lg:grid-rows-subgrid gap-y-20px lg:gap-y-[34px] max-lg:gap-y-[13px]',
            'p-20 pr-[32px] lg:p-[33px_17px_34px_32px]',
        ],
        listWrapper: [
            'mt-16 lg:mt-40 max-xl:mx-20',
            'grid grid-cols-1 lg:grid-cols-[minmax(auto,536px),minmax(auto,536px)] gap-16 lg:gap-40',
            'justify-center items-center',
            'relative',
        ],
    },
});
